export default __webpack_public_path__ + "static/media/delete.9436ff08.svg";